import React from "react";
import { Link } from "react-router-dom";

export default function LegalLayout({ title, updated, children, testId }) {
  return (
    <div className="min-h-screen bg-[#FAFAFA] text-[#09090B]" data-testid={testId}>
      <header className="border-b border-[#E4E4E7] bg-white">
        <div className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="legal-brand">
            <img
              src="/scanmint-logo.png"
              alt="ScanMint"
              className="h-9 w-auto select-none"
              draggable={false}
            />
          </Link>
          <Link
            to="/"
            className="text-sm text-[#0F8F4F] font-medium"
            data-testid="legal-back-home"
          >
            ← Back to home
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12 md:py-16">
        <div className="mono-tiny text-[#0F8F4F] mb-3">Legal</div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tighter">
          {title}
        </h1>
        {updated && (
          <p className="mt-3 text-sm text-[#71717A]">Last updated: {updated}</p>
        )}

        <article className="legal-content mt-10 text-[#27272A] leading-relaxed text-[15px]">
          {children}
        </article>

        <div className="mt-16 pt-8 border-t border-[#E4E4E7] flex flex-wrap gap-x-6 gap-y-2 text-sm">
          <Link to="/legal/privacy" className="text-[#0F8F4F] hover:underline" data-testid="legal-link-privacy">
            Privacy Policy
          </Link>
          <Link to="/legal/terms" className="text-[#0F8F4F] hover:underline" data-testid="legal-link-terms">
            Terms of Service
          </Link>
          <Link to="/legal/refund" className="text-[#0F8F4F] hover:underline" data-testid="legal-link-refund">
            Refund &amp; Cancellation Policy
          </Link>
        </div>
      </main>

      <footer className="border-t border-[#E4E4E7] bg-white">
        <div className="max-w-3xl mx-auto px-6 py-6 mono-tiny text-[#71717A] text-center">
          © 2026 ScanMint · All rights reserved
        </div>
      </footer>
    </div>
  );
}
